import { GraphQLApi } from '@maverick/http';
import { Config } from 'src/Config';

const graphQlEndpoint = String(Config.SitecoreGraphQLEndpoint);
const sitecoreApiKey = String(Config.SitecoreApiKey);

export const SitecoreClient = new GraphQLApi(graphQlEndpoint, { sc_apikey: sitecoreApiKey });
